import {useEffect} from 'react';
import useToken from '@/hooks/use-token';
import getLtid from '@/utils/getLtid';

function useLoggedInUserWithLtid(callback: (ltId: string) => void) {
  const {isAuthenticated, initialized} = useToken(true);

  useEffect(() => {
    if (initialized && isAuthenticated) {
      const ltId = getLtid();
      if (ltId) {
        callback(ltId);
      }
    }
  }, [initialized, isAuthenticated, callback]);
}

export default useLoggedInUserWithLtid;
